
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.333 7.667h3.334V4.333H.333v3.334zm0 4.166h3.334V8.5H.333v3.333zm0-8.333h3.334V.167H.333V3.5zM4.5 7.667h10V4.333h-10v3.334zm0 4.166h10V8.5h-10v3.333zM4.5.167V3.5h10V.167h-10z","fill":"#7A7A7A"}})])
          )
        }
      }
    